import React, { useState } from 'react';
import api from '../services/api';

const Login = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post('/login', { email, password });
            if (res.data.status === 'success') {
                localStorage.setItem('token', res.data.token);
                onLogin(res.data.user);
            } else {
                setError(res.data.message);
            }
        } catch (err) {
            setError('Login failed. Please check your credentials.');
        }
    };

    return (
        <div className="flex justify-center items-center h-screen bg-bg-body">
            <div className="bg-white rounded-lg p-8 border-2 border-border w-[90%] max-w-[400px]">
                <h2 className="mb-6 text-center text-2xl font-bold text-primary">Login to QMS</h2>
                {error && <div className="text-red-500 mb-4 text-sm font-medium">{error}</div>}
                <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-medium">Email</label>
                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="input-field" />
                    </div>
                    <div className="flex flex-col gap-2 mb-2">
                        <label className="text-sm font-medium">Password</label>
                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="input-field" />
                    </div>
                    <button type="submit" className="btn-primary w-full justify-center">Login</button>
                </form>
            </div>
        </div>
    );
};

export default Login;
